import styled from 'styled-components';

export const Dot = styled.span`
  border-radius: 50%;
  background-color: #000;
  display: inline-block;
  margin:0 10px;
  width: 5px;
  height: 5px;

  &:after {
    content:'';
    position: relative;
    bottom: 3px;
    right: 3px;
    border-radius: 50%;
    width: 9px;
    height: 9px;
    border: 1px solid #c5c5c5;
    display: ${props => props.active ? 'block' : 'none'};
  }
`;



// WEBPACK FOOTER //
// ./src/styles/Dot.js